import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Panel from 'components/Panel/Panel';
import Expandable from 'components/Shared/Expandable/Expandable';
import UserSnippet from '../UserSnippet';
import styles from './UserSnippets.module.scss';

export default class UserSnippets extends Component {
  static propTypes = {
    freelancers: PropTypes.array,
    linksActive: PropTypes.bool,
    expandable: PropTypes.bool,
  };

  render() {
    const { expandable, linksActive, freelancers, ...rest } = this.props;
    return expandable ? (
      <Expandable title="Invited freelancers">
        {freelancers.length > 0 ? (
          freelancers.map((freelancer) => (
            <div className={styles.snippet}>
              <UserSnippet active={linksActive} user={freelancer} />
            </div>
          ))
        ) : (
          <noscript />
        )}
      </Expandable>
    ) : (
      <Panel {...rest}>
        <Panel.Header>Invited freelancers</Panel.Header>
        <hr style={{ margin: 0 }} />
        {freelancers.length > 0 &&
          freelancers.map((freelancer) => (
            <div className={styles.snippet}>
              <UserSnippet active={linksActive} user={freelancer} />
            </div>
          ))}
      </Panel>
    );
  }
}
